export default "__VITE_ASSET__aWdQrYuo__"